<template lang="pug">
  v-card
    v-card-title
      v-spacer
      v-btn( @click='solicitar({acción: "solicitar_cerrar_agregar_card"})' icon color='primary' x-small )
        v-icon(x-small) fa-times
    v-card-text(@keyup.enter='solicitar({acción: "solicitar_agregar_elemento", llave, contenido, tipo})')
      v-row(align='center')
        v-col.py-0()
          v-combobox( :items='tipo_de_contenedor == "Arreglo" ? Tipos.filter(item=>item != "Arreglo") : Tipos' v-model='tipo' )  
        v-col.py-0( v-if='tipo_de_contenedor == "Objeto"' )
          v-text-field(  label='Llave' v-model='llave')
        v-col.py-0( v-if=' tipo=="Texto"')
          v-text-field( label='Contenido' v-model='contenido')
        v-col 
          Seleccionar_imagen_dialog( v-if='tipo=="Texto"' @seleccionar_imagen='val=>contenido=val') 
        v-col.py-0
          v-btn( color='primary' icon small @click='solicitar({acción: "solicitar_agregar_elemento", llave, contenido, tipo})' )
            v-icon(small ) fa-plus 

</template>
<script>
import {mapState} from 'vuex'
export default {
  data: ()=>({
    tipo: '',
    llave: '',
    contenido: '',
  }),
  props: [
    'tipo_de_contenedor'
  ],
  methods: {
    solicitar(objeto) {
      this.$emit('solicitar', objeto)
    },
  },
  computed:{
    ...mapState({
      Tipos: state => state.CMS.tipos,
    }),
  
  
  },
  components: {
    Agregar_imagen_boton: ()=>import('./agregar_imagen_boton.vue'),
    Seleccionar_imagen_dialog: ()=>import('./seleccionar_imagen_dialog')
  }
}
</script>